/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Refill_Price_Per_MessageInputs */

const es_admin_billing_last_refill_price_per_message = /** @type {(inputs: Admin_Billing_Last_Refill_Price_Per_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio por mensaje`)
};

const en_admin_billing_last_refill_price_per_message = /** @type {(inputs: Admin_Billing_Last_Refill_Price_Per_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price per message`)
};

/**
* | output |
* | --- |
* | "Price per message" |
*
* @param {Admin_Billing_Last_Refill_Price_Per_MessageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_refill_price_per_message = /** @type {((inputs?: Admin_Billing_Last_Refill_Price_Per_MessageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Refill_Price_Per_MessageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_refill_price_per_message(inputs)
	return en_admin_billing_last_refill_price_per_message(inputs)
});
export { admin_billing_last_refill_price_per_message as "admin.billing.last_refill.price_per_message" }